var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"suggested-wrapper",on:{"click":function($event){$event.stopPropagation();}}},[_c('Category',{attrs:{"level-label":_vm.levelLabel,"category-name":_vm.categoryName,"publications":_vm.suggestedBooks}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }